
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/closed/[id]",
      function () {
        return require("private-next-pages/closed/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/closed/[id]"])
      });
    }
  